import toast from "react-hot-toast";
import { formatNumber } from "../../utils/utils";

const { clientAPI } = require("../client");

const formatStatus = (status) => {
  switch (status) {
    case "NEW":
      return "Mới";
    case "REJECTED":
      return "Từ chối";
    case "APPROVED":
      return "Đã duyệt";
    case "REFUND":
      return "Hoàn trả";
    case "EDITING":
      return "Yêu cầu chỉnh sửa";
    default:
      return "";
  }
};

export const apartmentCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/apartment", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/apartment/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await clientAPI("delete", `/apartment/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  export: async (entries, param, getRoleUser) => {
    try {
      const options = {
        limit: entries,
        page: 1,
      };

      if (param.search) options.search = param.search;
      if (param.apartmentTypeId)
        options.apartmentTypeId = param.apartmentTypeId;
      if (param.projectId) options.projectId = param.projectId;
      if (param.totalValue) options.totalValue = param.totalValue;
      if (param.priceForCommission)
        options.priceForCommission = param.priceForCommission;
      if (param.estimatedServiceFeePrice)
        options.estimatedServiceFeePrice = param.estimatedServiceFeePrice;
      if (param.saleOpeningEvent?.length > 0)
        options.saleOpeningEventId = param.saleOpeningEvent;
      if (param.apartmentTypeId)
        options.apartmentTypeId = param.apartmentTypeId;

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/apartment?${queryParams}`);

      const dataExport = response?.items.map((item, index) => {
        return {
          code: item?.code || "-",
          name: item?.name || "",
          area: item?.area || "",
          builtUpArea: item?.builtUpArea || "",
          width: item?.width || "",
          length: item?.length || "",
          numberOfBedrooms: item?.numberOfBedrooms || "",
          numberOfToilets: item?.numberOfToilets || "",
          direction: item?.direction?.name || "",
          apartmentType: item?.apartmentType?.name || "",
          property: item?.property?.name || "",
          project: item?.project?.name || "",
          division: item?.division?.name || "",
          totalValue: item?.totalValue || "",
          priceForCommission: item?.priceForCommission || "",
          estimatedServiceFeePrice: item?.estimatedServiceFeePrice || "",
          saleOpeningEvents:
            Array.isArray(item?.saleOpeningEvents) &&
              item.saleOpeningEvents.length
              ? item.saleOpeningEvents.map((e) => e.name).join(", ")
              : "-",
          // ...(getRoleUser && {
          //   commissionFromInvestor: item?.commissionFromInvestor || 0,
          // }),
          // ...(getRoleUser && {
          //   commissionToSales: item?.commissionToSales || 0,
          // }),
          // ...(getRoleUser && {
          //   commissionFromPartner: item?.commissionFromPartner || 0,
          // }),
        };
      });

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  exportV2: async (entries, param) => {
    try {
      const options = {
        limit: entries,
        page: 1,
      };

      if (param.search) options.search = param.search;
      if (param.apartmentTypeId)
        options.apartmentTypeId = param.apartmentTypeId;
      if (param.projectId) options.projectId = param.projectId;
      if (param.totalValue) options.totalValue = param.totalValue;
      if (param.priceForCommission)
        options.priceForCommission = param.priceForCommission;
      if (param.estimatedServiceFeePrice)
        options.estimatedServiceFeePrice = param.estimatedServiceFeePrice;
      if (param.saleOpeningEvent?.length > 0)
        options.saleOpeningEventId = param.saleOpeningEvent;
      if (param.apartmentTypeId)
        options.apartmentTypeId = param.apartmentTypeId;

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/apartment?${queryParams}`);

      const dataExport = response?.items.map((item, index) => {
        return {
          code: item?.code || "", // Mã sản phẩm
          projectCode: item?.project?.code || "", // Mã dự án
          saleOpeningEventCode: item?.saleOpeningEvent?.code || "", // Mã đợt mở bán
          booking: (item?.booking && item?.booking?.status !== "REJECTED") ? "Có" : "không", // Trạng thái booking
          locking: (item?.locking && item?.locking?.status !== "REJECTED") ? "Có" : "không", // Trạng thái locking
          is_hidden: item?.is_hidden ? "Đã bán" : "Chưa bán", // Đã bán
          totalValue: item?.totalValue || 0, // Giá niêm yết
          priceForCommission: item?.priceForCommission || 0, // Giá tính phí dịch vụ
          estimatedServiceFeePrice: item?.estimatedServiceFeePrice || 0, // Giá tính phí dịch vụ ước tính
          transactionRate: item?.transactionRate || 0, // Tỉ lệ nhận về
          rateTNSan: item?.rateTNSan || 0, // Tỉ lệ thưởng nóng sàn
          priceTNSan: item?.priceTNSan || 0, // Số tiền thưởng nóng sàn
          direction: item?.direction?.name || "", // Hướng
          division: item?.division?.name || "", // Phân khu
          apartmentType: item?.apartmentType?.name || "", // Loại căn hộ
          property: item?.property?.name || "", // Tính chất
          area: item?.area || "", // Diện tích
          builtUpArea: item?.builtUpArea || "", // Diện tích xây dựng
          length: item?.length || "", // Chiều dài
          width: item?.width || "", // Chiều rộng
          numberOfBedrooms: item?.numberOfBedrooms || "", // Số phòng ngủ
          numberOfToilets: item?.numberOfToilets || "", // Số phòng vệ sinh
        };
      });

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  bulkAdd: async (data) => {
    try {
      const response = await clientAPI("post", "/apartment/bulkCreate/", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  bulkAddPrice: async (data) => {
    try {
      const response = await clientAPI("post", "/apartment/bulkPrice/", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  bulkAddRate: async (data) => {
    try {
      const response = await clientAPI("post", "/apartment/bulkRate/", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  deleteMany: async (data) => {
    try {
      const response = await clientAPI("post", "/apartment/deleteMany", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getById: async (id) => {
    try {
      const response = await clientAPI("get", `/apartment/${id}`);
      return response;
    } catch (error) {
      console.error("Get by id error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
